import NotFoundPage from "../pages/NotFoundPage";
import OpeningWarehouseHome from "../pages/opening_warehouse/Home";
import FeastStaffHome from "../pages/festa_staff/Home";
import OpeningWarehouseLayout from "../pages/opening_warehouse/Layout";
import OpeningWarehouseLikeProduct from "../pages/opening_warehouse/LikeProduct";
import FestaStaffLayout from "../pages/festa_staff/Layout";
import OpeningWarehouseSearchProduct from "../pages/opening_warehouse/SearchProduct";
import FeastStaffSearchProduct from "../pages/festa_staff/SearchProduct";
import FeastStaffSearchExperience from "../pages/festa_staff/SearchExperience";
import UrlValidation, { EventType } from "../components/UrlValidation";
import { Navigate } from "react-router-dom";
import PajuspielLayout from "../pages/pajuspiel/Layout";
import PajuspielHome from "../pages/pajuspiel/Home";
import PajuspielSearchProduct from "../pages/pajuspiel/SearchProduct";
import ParcelLayout from "../pages/parcel/Layout";
import ParcelHome from "../pages/parcel/Home";
import ParcelSearchProduct from "../pages/parcel/SearchProduct";
import ParcelLikeProduct from "../pages/parcel/CartProduct";
import AdminOutlet from "../pages/admin/AdminOutlet";
import AdminLogin from "../pages/admin/Login";
import AdminLayout from "../pages/admin/Layout";
import AdminHome from "../pages/admin/Home";
import AdminDelivery from "../pages/admin/AdminDelivery";
import ProductRegister from "../pages/admin/ProductRegister";
import RequireAdmin from "../components/admin/RequireAdmin";

type ComponentProps = {
  Component: React.ElementType; // ReactNode로 children을 받음
};

const OpeningWarehouseElement: React.FC<ComponentProps> = ({ Component }) => {
  return (
    <UrlValidation type={EventType.OPENING_WAREHOUSE}>
      <Component />
    </UrlValidation>
  );
};

const FestaElement: React.FC<ComponentProps> = ({ Component }) => {
  return (
    <UrlValidation type={EventType.FESTA}>
      <Component />
    </UrlValidation>
  );
};

const PajuspielElement: React.FC<ComponentProps> = ({ Component }) => {
  return (
    <UrlValidation type={EventType.PAJUSPIEL}>
      <Component />
    </UrlValidation>
  );
};

const AppRouter = [
  { path: "*", element: <Navigate to={"/error"} /> },
  { path: "/error", element: <NotFoundPage /> },
  {
    path: "/admin",
    element: <AdminOutlet />,
    children: [
      { path: "login", element: <AdminLogin /> },
      {
        element: (
          <RequireAdmin>
            <AdminLayout />
          </RequireAdmin>
        ),
        children: [
          { index: true, element: <AdminHome /> },
          { path: "product-register", element: <ProductRegister /> },
          { path: "delivery", element: <AdminDelivery /> },
        ],
      },
    ],
  },
  {
    path: "/parcel",
    element: <ParcelLayout />,
    children: [
      {
        path: "/parcel",
        element: <FestaElement Component={ParcelHome} />,
      },
      {
        path: "/parcel/search-product",
        element: <FestaElement Component={ParcelSearchProduct} />,
      },
      {
        path: "/parcel/cart",
        element: <FestaElement Component={ParcelLikeProduct} />,
      },
      {
        path: "/parcel/orders",
        element: <Navigate to="/admin/delivery" replace />,
      },
    ],
  },
  {
    path: "/festa",
    element: <FestaStaffLayout />,
    children: [
      {
        path: "/festa",
        element: <FestaElement Component={FeastStaffHome} />,
      },
      {
        path: "/festa/search-product",
        element: <FestaElement Component={FeastStaffSearchProduct} />,
      },
      {
        path: "/festa/search-experience",
        element: <FestaElement Component={FeastStaffSearchExperience} />,
      },
    ],
  },
  {
    path: "/opening-warehouse",
    element: <OpeningWarehouseLayout />,
    children: [
      {
        path: "/opening-warehouse",
        element: <OpeningWarehouseElement Component={OpeningWarehouseHome} />,
      },
      {
        path: "/opening-warehouse/search-product",
        element: (
          <OpeningWarehouseElement Component={OpeningWarehouseSearchProduct} />
        ),
      },
      {
        path: "/opening-warehouse/like-product",
        element: (
          <OpeningWarehouseElement Component={OpeningWarehouseLikeProduct} />
        ),
      },
    ],
  },
  {
    path: "/pajuspiel",
    element: <PajuspielLayout />,
    children: [
      {
        path: "/pajuspiel",
        element: <PajuspielElement Component={PajuspielHome} />,
      },
      {
        path: "/pajuspiel/search-product",
        element: <PajuspielElement Component={PajuspielSearchProduct} />,
      },
    ],
  },
];

export default AppRouter;
